import * as React from 'react'
import { useState } from 'react'
import { useTranslation } from 'react-i18next'

import AlbumItem from './albumItem'
import UploadPhotoPopup from '../popups/uploadPhotoPopup'
import WithPhotoSlider, { WithPhotoSliderProps } from '../../../hoc/withPhotoSlider'

import { AlbumType, PhotoType } from '../../../store/commonTypes'

import isEmpty from 'lodash/isEmpty'
import s from './materialPreview.module.sass'
import { useSelector } from 'react-redux'
import { RootState } from '../../../store/rootReducer'

interface Props extends WithPhotoSliderProps {
    self?: boolean
    album: AlbumType
    type?: string
}

const Album: React.FunctionComponent<Props> = ({ album, openPhoto, self }: Props) => {
    const [t] = useTranslation()
    const [showPopup, setShowPopup] = useState(false)
    const isAgeVerified = useSelector((state: RootState) => state.common.isAgeVerified)
    const emptyAlbum = isEmpty(album.list)

    return (
        <div className={s['materialsPreview']}>
            <div className={s['materialsPreview__row']}>
                <div className={s['materialsPreview__row']}>
                    <div className={s['materialsPreview__title']}>{album.title}</div>
                    <div className={s['materialsPreview__counter']}>
                        {!emptyAlbum &&
                            album.list.length + (self ? (album.id === 'free' ? t('of 20') : t('of 40')) : '')}
                    </div>
                </div>
            </div>
            <div className={s['materialsPreview__list']}>
                {album.list.map((photo: PhotoType) => (
                    <AlbumItem
                        photo={photo}
                        openPhoto={openPhoto}
                        key={photo.id}
                        isPro={album.id === 'pro'}
                        isAgeVerified={isAgeVerified}
                    />
                ))}
            </div>
            {showPopup && <UploadPhotoPopup onClose={() => setShowPopup(false)} />}
        </div>
    )
}

export default WithPhotoSlider()(Album)
